import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import colors, { withOpacity } from '@wecasa/common/src/utils/colors';
import { toRem } from '@wecasa/common/src/utils/styles';

import type { CommonCleaningBasketProps } from '@wecasa/customer/src/components/basket/types';
import {
  getAppointmentAccordionTitle,
  getAppointmentDescriptionIfNoSecondary,
} from '@wecasa/customer/src/utils/basket';

import { translate } from '@wecasa/i18n';

import Accordion from '@wecasa/web-ui/src/components/accordion/accordion';
import Text from '@wecasa/web-ui/src/components/base-text/variants/text';
import Separator from '@wecasa/web-ui/src/components/separator/separator';

import useBasketSection from '../../../../../../hooks/use-basket-section';
import { route } from '../../../../../../steps/steps';
import CleaningAppointmentDetails from './single-cleaning-appointment-details';

const t = translate('basket');

const StyledAccordion = styled(Accordion)`
  margin: ${toRem(20)} 0;
`;

type SingleCleaningAppointmentsProps = Pick<CommonCleaningBasketProps, 'appointment' | 'appointmentDate'>;

const SingleCleaningAppointments = ({ appointment, appointmentDate }: SingleCleaningAppointmentsProps) => {
  const { primary, secondary } = appointment;
  const { isOpen, isVisible } = useBasketSection({
    data: !!primary,
    sectionLocations: [route('appointment_calendar'), route('appointment_hour')],
  });

  const { pathname } = useLocation();

  const subTitleKey = '.secondary_appointment';

  const subtitle = secondary.length ? <Text.SM>{t(subTitleKey, { count: secondary.length })}</Text.SM> : undefined;

  if (!isVisible) return null;

  return (
    <>
      <Separator />
      <StyledAccordion
        icon='clock-filled'
        iconLabel={t('.appointment_icon_label')}
        title={getAppointmentAccordionTitle({
          primary,
          appointmentDate,
          weeklyRecurrence: 0,
        })}
        subtitle={subtitle}
        isOpen={isOpen}
      >
        {secondary.length > 0 ? (
          <CleaningAppointmentDetails appointment={appointment} />
        ) : (
          <Text.SM color={withOpacity(colors.neutral100, 0.5)}>
            {getAppointmentDescriptionIfNoSecondary({
              primary,
              appointmentDate,
              weeklyRecurrence: 0,
              isOnCalendarScreen: pathname === route('appointment_calendar'),
            })}
          </Text.SM>
        )}
      </StyledAccordion>
    </>
  );
};

export default SingleCleaningAppointments;
